import {valueSchema, validationSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'number_of_workers_under_18'

export const dataPointDefinition = {
  retracedId: 'number_of_workers_under_18',
  name: 'Number of workers under the age of 18',
  description:
    'This question applies equally to current workers under the age of 18 AND workers who were 18 during the assessment timeframe, but no longer are 18 or no longer are present. \r\r\n\r\r\nNote to facilities and Verifiers: The assessment timeframe includes the entire self/joint-assessment timeframe and the current situation on site during verification. ',
  meta: {
    rangeValidation: true,
    optionalRange: true,
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-ed-12',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1530,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = async (data, {validatorFn}) => {
  try {
    validate({value: data, schema: valueSchema})

    if (!validatorFn) {
      return data
    }

    if (validatorFn && typeof validatorFn !== 'function') {
      throw new Error(`expect range limits function to be a function, got ${typeof validatorFn}`)
    }

    const {value} = data

    const rangeValues = await validatorFn()
    validate({value: rangeValues, schema: validationSchema})

    const {min, max} = rangeValues
    if (min && value < min) {
      throw new Error('data mismatch, value is less than minimum allowed value')
    }

    if (max && value > max) {
      throw new Error('data mismatch, value is greater than maximum allowed value')
    }

    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
